<template>
  <div>
    <nav-bar-jitsi
      v-show="inMeeting && !javaCall"
      :meeting-name="meetingName"
      :meeting-info="meetingInfo"
      fixed="top"/>
    <side-bar-jitsi
      v-if="inMeeting"
      v-show="!javaMinimized"
      ref="sideBar" />
    <b-container
      ref="containerMeeting"
      :class="{ pushed: expanded, meeting: inMeeting}"
      fluid>
      <div>
        <settings-jitsi
          v-if="inMeeting"
          ref="settings"/>
      </div>
      <div>
        <make-moderator/>
      </div>
      <div>
        <leave-meeting ref="leaveMeeting"/>
      </div>
      <div>
        <recording-notify
          v-if="inMeeting"
          ref="recordingNotify"/>
      </div>
      <div
        v-if="!inMeeting && directly"
        class="text-center rounded connecting mx-auto">
        <div class="spinner-border text-primary m-4">
          <span class="sr-only">{{ $t('MEETING.LOADING') }}</span>
        </div>
        <div class="small">{{ $t('MEETING.CONNECTING') }}</div>
      </div>
      <configure-devices-jitsi ref="configdevices"/>
      <div
        v-show="inMeeting && !javaMinimized"
        ref="meet"
        class="overflow-hidden videoArea"
      />
    </b-container>
    <div
    fixed="bottom">
      <meeting-controls-jitsi
        v-if="inMeeting"
        ref="meetingControls"
        :class="{ pushed: expanded }"
        class="menuBar"
      />
    </div>
  </div>
</template>

<script>
import {isMobile, isIos, getBrowser} from "../functions/browserDetails"
import {ref, onMounted} from "@vue/composition-api"
import {parseJwt} from "../functions/globalMethods"
import {getJitsiToken, saveJitsiToken, removeJitsiToken, loadStorageData, getItem, saveCorenexaToken, getCorenexaToken, setItem} from "../functions/storageManager"
import MeetingControlsJitsi from './MeetingControlsJitsi'
import SideBarJitsi from "./SideBarJitsi"
import NavBarJitsi from "./NavBarJitsi"
import SettingsJitsi from "./SettingsJitsi"
import RecordingNotify from "./RecordingNotify"
import LeaveMeeting from './LeaveMeeting'
import ConfigureDevicesJitsi from './ConfigureDevicesJitsi'
import MakeModerator from './MakeModerator.vue'

export default {
  name: 'JoinMeeting',
  components: {
    'meeting-controls-jitsi': MeetingControlsJitsi,
    'side-bar-jitsi': SideBarJitsi,
    'leave-meeting': LeaveMeeting,
    'make-moderator': MakeModerator,
    'nav-bar-jitsi': NavBarJitsi,
    'settings-jitsi': SettingsJitsi,
    'recording-notify': RecordingNotify,
    'configure-devices-jitsi': ConfigureDevicesJitsi
  },
  setup(props, context) {
    const expanded = ref(false)
    const inMeeting = ref(false)
    const domain = ref("150-136-245-73-meta.corenexa.com:9443") //Here goes your domain where the meeting takes place.
    const isStreamOn = ref(false) //This is a variable I've defined to use later.
    const meet = ref(null)
    const options = ref({})
    const api = ref({})
    const meta_token = ref('')
    const corenexa_token = ref('')
    const roomName = ref('')
    const meetingName = ref("")
    const meetingInfo = ref({})
    const numberOfPeople = ref(0)
    const cnv_api = ref('https://api.corenexa.com')
    const storedMicSettings = ref({deviceId: null, groupId: null, kind: "audioinput", label: ""})
    const storedCameraSettings = ref({deviceId: null, groupId: null, kind: "videoinput", label: ""})
    const storedSpeakerSettings = ref({deviceId: null, groupId: null, kind: "audiooutput", label: ""})
    document.body.style.backgroundColor = "#141414"
    const javaCall = ref(false)
    const javaMinimized = ref(false)
    const directly = ref(false)
    const userWantsToLeave = ref(false)
    const rejoinHref = ref(window.location.href)

    loadStorageData()
    /* if (getItem('meetingData') !== undefined) {
      directly.value = getItem('meetingData')
    } */
    window.javaSetMinimizeMode = setMinimizeMode

    let storedJitsiToken = getJitsiToken()
    let href = window.location.href
    if (context.root.$route.query.r) {
      meta_token.value = context.root.$route.query.r
      window.location.href = href.replace(`r=${meta_token.value}`, "")
      href = window.location.href
    } else if (context.root.$route.query.u) {
      meta_token.value = context.root.$route.query.u
      window.location.href = href.replace(`u=${meta_token.value}`, "")
      href = window.location.href
    } else if (storedJitsiToken) {
      meta_token.value = storedJitsiToken
    }
    if(meta_token.value) {
      saveJitsiToken(meta_token.value)
    }
    if (jitsiTokenExpired()) {
      window.location.href ='/#/'
      window.location.reload()
    }
    if (context.root.$route.query.meetingID) {
      roomName.value = context.root.$route.query.meetingID
      window.location.href = href.replace(`meetingID=${roomName.value}`, "")
      href = window.location.href
    }
    let storedCorenexaToken = getCorenexaToken()
    if (context.root.$route.query.c) {
      corenexa_token.value = context.root.$route.query.c
      window.location.href = href.replace(`c=${corenexa_token.value}`, "")
      href = window.location.href
    } else if (storedCorenexaToken) {
      corenexa_token.value = storedCorenexaToken
    }
    if(corenexa_token.value) {
      saveCorenexaToken(corenexa_token.value)
    }
    if (context.root.$route.query.domain) {
      domain.value = context.root.$route.query.domain
    }
    if (context.root.$route.query.api) {
      cnv_api.value = context.root.$route.query.api
    }
    /* context.refs.configdevices.configureDevices()
    if (context.root.$route.query.directly) {
      meetingData.value.directly = context.root.$route.query.directly
    }
    loadJsFile('https://' + domain.value + '/external_api.js') */
    // refreshDevices()
    
    /* async function refreshDevices() {
      let devices = await navigator.mediaDevices.enumerateDevices()
      if (getItem('miceId') !== undefined) {
        let found = devices.find((E) => {
          return E.deviceId == getItem('miceId') && E.kind == 'audioinput'
        })
        if (found)
          storedMicSettings.value = found
      }
      if (getItem('cameraId') !== undefined) {
        let found = devices.find((E) => {
          return E.deviceId == getItem('cameraId') && E.kind == 'videoinput'
        })
        if (found)
          storedCameraSettings.value = found
      }
      if (getItem('sinkID') !== undefined) {
        let found = devices.find((E) => {
          return E.deviceId == getItem('sinkId') && E.kind == 'audiooutput'
        })
        if (found)
          storedSpeakerSettings.value = found
      }
      context.refs.configDevices.configureDevices()
      if (context.root.$route.query.directly) {
        meetingData.value.directly = context.root.$route.query.directly
      }
      loadJsFile('https://' + domain.value + '/external_api.js')
    } */

    onMounted(async () => {
      await context.refs.configdevices.configureDevices()
      if (context.root.$route.query.directly) {
        directly.value = context.root.$route.query.directly
      } else if (getItem('directly') !== undefined) {
        directly.value = getItem('directly')
      }
      loadJsFile('https://' + domain.value + '/external_api.js')
    })

    function loadJsFile(filePath) {
      // Create a <script> tag, set its source
      let scriptTag = document.createElement('script')

      // And listen to it
      scriptTag.onload = function (loadEvent) {
        // This function is an event handler of the script tag
        if (directly.value)
          joinJitsi()
      }

      // Make sure this file actually loads instead of a cached version
      // Add a timestamp onto the URL (i.e. file.js?bust=12345678)
      let cacheBuster = '?bust=' + new Date().getTime()

      // Set the type of file and where it can be found
      scriptTag.type = 'text/javascript'
      scriptTag.src = filePath + cacheBuster

      // Finally add it to the <head>
      document.getElementsByTagName('head')[0].appendChild(scriptTag)
    }

    function joinJitsi() {
      options.value = {
        roomName: roomName.value, //This is the name of the room. Quite obvious.
        width: "100%",
        height: "100%",
        parentNode: meet.value, //Now, you declare here which element should parent your stream.
        configOverwrite: {
          toolbarButtons: [],
          //toolbarConfig: {initialTimeout: 1, timeout: 1},
          prejoinConfig: [false, false,[]],
          prejoinPageEnabled: false,
          disableSelfViewSettings: true,
          useHostPageLocalStorage: true,
          hideConferenceSubject: true,
          hideConferenceTimer: true,
          startWithAudioMuted: getItem('miceOn') !== undefined ? !getItem('miceOn') : true,
          startWithVideoMuted: getItem('cameraOn') !== undefined ? !getItem('cameraOn') : true,
          disableDeepLinking: true,
          localRecording: {
            disable: false,
            notifyAllParticipants: true,
            disableSelfRecording: true
          },
          videoQuality: {
            maxBitratesVideo: {
              VP8: {low: 100000, standard: 400000, high: 1000000}
            }
          }
        },
        jwt: meta_token.value,
        devices: { audioOutput: '', audioInput: '', videoInput: ''}
			}
      if (storedMicSettings.value.deviceId != null)
        options.value.devices.audioInput = storedMicSettings.value.label
      if (storedSpeakerSettings.value.deviceId != null) {
        options.value.devices.audioOutput = storedSpeakerSettings.value.label
      }
      if (storedCameraSettings.value.deviceId != null)
        options.value.devices.videoInput = storedCameraSettings.value.label
      if (getBrowser().firefox) {
        options.value.configOverwrite.enableTcc = false
        options.value.configOverwrite.disableRtx = true
      }
      context.root.api = new JitsiMeetExternalAPI(domain.value, options.value) //This is where the iframe is actually constructed
      context.root.api.addEventListener(`videoConferenceJoined`, (value) => {
        meetingName.value = context.root.$route.query.meetingName ? context.root.$route.query.meetingName : roomName.value
        inMeeting.value = true
        if (window.java) {
          javaCall.value = true
          context.refs.containerMeeting.style.marginTop = '0px'
          context.refs.containerMeeting.style.setProperty('height', 'calc(100vh - 48px)', 'important')
        } /* else {
          askMeetingInfo()
        } */
      })
      // move out, it does not make a sence and did not help with UCWEB-263
      /* context.root.api.addEventListener('videoConferenceLeft', (e) => {
        if (!userWantsToLeave.value) {
          console.warn('videoConferenceLeft', e)
          window.location.reload()
        }
      }) */
      context.root.api.addEventListener('errorOccurred', (e) => {
        console.warn('errorOccurred', e)
      })
    }

    function setMinimizeMode(value) {
      javaCall.value = true
      if (context.refs.containerMeeting && context.refs.meetingControls) {
        context.refs.containerMeeting.style.marginTop = '0px'
        context.refs.containerMeeting.style.setProperty('height', 'calc(100vh - 48px)', 'important')
        javaMinimized.value = value
        context.refs.meetingControls.desktopMinimizedMode = value
        if (javaMinimized.value) {
          context.refs.meetingControls.$el.style.setProperty('width', '100%')
          context.refs.meetingControls.$el.style.marginLeft = '0px'
          expanded.value = false
          if (context.refs.sideBar) {
            context.refs.sideBar.chat = false
            context.refs.sideBar.participant = false
          }
        } else {
          context.refs.meetingControls.$el.style.setProperty('width', 'calc(100% - 48px)')
          context.refs.meetingControls.$el.style.marginLeft = '48px'
        }
      }
    }

    function exitMeeting() {
      context.refs.meetingControls.exitMeeting(true)
    }

    async function askMeetingInfo() {
      meetingInfo.value = {}
      let token = parseJwt(meta_token.value)
      if (corenexa_token.value != '') {
        const headers = { "Content-Type": "application/json", 'Authorization': 'Bearer ' + corenexa_token.value }
        try {
          let meetingID = token.meetingID ? token.meetingID : token.room
          let response = await fetch(cnv_api.value + "/v1/meeting/" + meetingID, { headers })
          let json = await response.json() || {}
          if (json.error) {
            console.log('failed to get meeting details:', json.error)
          } else {
            meetingInfo.value = json
            meetingInfo.value.isModerator = token.moderator
            meetingInfo.value.guest = false
          }
        } catch (error) {
          console.log('failed to get meeting details:', error)
        }
      } else {
        let meetingID = token.meetingID ? token.meetingID : token.room
        meetingInfo.value.guest = true
        meetingInfo.value.ID = meetingID
        meetingInfo.value.title = meetingName.value
      }
    }

    function jitsiTokenExpired() {
      if (!meta_token.value) {
        return true;
      }

      let token = parseJwt(meta_token.value);
      if (Date.now() > token.exp * 1000) {
        return true;
      }

      return false;
    }

    async function putModeratorKey(key) {
      let me = context.refs.sideBar.$refs.sidePart.myUser
      let token = parseJwt(meta_token.value)
      const headers = { "Content-Type": "application/json", 'Authorization': 'Bearer ' + corenexa_token.value }
      try {
        let params = {
          modPin: key,
          username: me.displayName,
          meetingID: token.meetingID ? token.meetingID : token.room
        }
        if (me.avatarUrl) {
          params.avatar = me.avatarUrl
        }

        let response = await fetch(cnv_api.value + "/pub/joinMeeting?" + new URLSearchParams(params).toString(), { headers })
        let json = await response.json() || {}
        if (response.status === 200) {
          var paramsJoin = new URLSearchParams({
                        meetingID: json.meetingID,
                        meetingName: json.meetingName,
                        domain: json.domain,
                        r: json.jwt,
                        c: corenexa_token.value,
                        api: cnv_api.value,
                        network: json.network,
                        directly: true
                      });
          window.location.href ='/#/JoinMeeting?' + paramsJoin.toString()
          window.location.reload()
        } else if (response.status === 401 && json.error === 'Wrong modPin') {
          context.root.$notify.info(context.root.$t("MEETING.POPUP_MODKEY_DONT_MATCH"), {visibility: 10000, closeButtonClass:'close'})
        }
      } catch (error) {
        console.log('Error while making user a moderator:', error)
      }
    }

    return {
      directly,
      expanded,
      inMeeting,
      domain,
      options,
      meetingName,
      meetingInfo,
      api,
      meta_token,
      corenexa_token,
      cnv_api,
      putModeratorKey,
      roomName,
      meet,
      exitMeeting,
      isMobile,
      isIos,
      setMinimizeMode,
      javaCall,
      javaMinimized,
      numberOfPeople,
      askMeetingInfo,
      loadJsFile,
      storedMicSettings,
      storedCameraSettings,
      storedSpeakerSettings,
      userWantsToLeave,
      joinJitsi,
      rejoinHref
    }
  }
}
</script>
<style>
#popup{
  display: none;
}
</style>
<style scoped>
  .pushed{ width:calc(100% - 370px)!important; margin-left: 370px!important;}
  .spinner-border{
    width: 56px;
    height: 56px;
  }
  .connecting{
    background: #272727;
    max-width: 500px;
    padding: 40px;
    margin-top: 80px;
  }
  .small{
    color: #bbbbbb;
  }
  .mobileHeight{
    padding: 13px;
  }
  .container-fluid.meeting{
    width: calc(100% - 48px);
    height: calc(100vh - 90px) !important;

    margin-top: 42px;
  }
  @media (min-width: 768px) {
    .container-fluid.meeting{
      margin-left: 48px;
      display: inherit;
    }
  }
  .videoArea {
    height: 100%;
    margin-left: -15px;
    margin-right: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/JoinMeeting.vue